var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.images.length)?_c('slider',{ref:"slider",staticClass:"b-gallery",attrs:{"slides":_vm.data.images,"fullheight":true,"prevNext":true,"show-index":true,"zoom":true,"modifier":"gallery","options":{
        wrapAround: true,
        draggable: false,
    }},scopedSlots:_vm._u([{key:"slide",fn:function(image){return [_c('asset',{attrs:{"asset":image,"rounded":true},on:{"loaded":function($event){return _vm.refreshSlider()}}})]}}],null,false,42035022)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }